export const DEFAULT_APPEARANCE = {
  theme: "light",
  primaryColor: "#3b82f6",
  secondaryColor: "#6b7280",
  fontSize: "medium",
  compactMode: false,
  showAnimations: true,
  sidebarCollapsed: false,
  showBreadcrumbs: true,
};

const FONT_SIZE_PX = {
  small: "14px",
  medium: "16px",
  large: "18px",
};

export const mergeAppearance = (appearance) => ({
  ...DEFAULT_APPEARANCE,
  ...(appearance ?? {}),
});

export const resolveFontSizePx = (fontSize) => FONT_SIZE_PX[fontSize] ?? FONT_SIZE_PX.medium;

export const resolvePaletteMode = (themePreference, systemPrefersDark) => {
  if (themePreference === "dark") return "dark";
  if (themePreference === "light") return "light";
  return systemPrefersDark ? "dark" : "light";
};
